import React from 'react';
import { Handle, Position } from 'reactflow';
import { MessageSquare } from 'lucide-react';

const PromptNode = ({ data, isConnectable }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-blue-200 node-prompt">
      <div className="flex items-center">
        <MessageSquare className="w-4 h-4 text-blue-600 mr-2" />
        <div className="ml-2">
          <div className="text-lg font-bold text-blue-800">Prompt Block</div>
          <div className="text-sm text-gray-600">
            {data.config?.prompt || 'Enter your prompt...'}
          </div>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-blue-500 border-2 border-white"
      />
    </div>
  );
};

export default PromptNode;